import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import '../../css/StorageIndicator.css';

const BLUEBIRD_DOCS_URL = 'https://bluebird-documentation.com';

const StorageIndicator = () => {
    const { apiCall, user } = useAuth();
    const [storageInfo, setStorageInfo] = useState(null);

    const fetchStorage = useCallback(async () => {
        try {
            const response = await apiCall('/tasks/storage/');
            if (response.ok) {
                const data = await response.json();
                setStorageInfo(data);
            }
        } catch (err) {
            console.error('Error fetching storage info:', err);
        }
    }, [apiCall]);

    useEffect(() => {
        fetchStorage();
    }, [fetchStorage]);

    const formatBytes = (bytes) => {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    };

    const getBarClass = (percentage) => {
        if (percentage >= 90) return 'StorageIndicator__bar-fill--danger';
        if (percentage >= 75) return 'StorageIndicator__bar-fill--warning';
        return '';
    };

    if (!storageInfo) return null;

    const percentage = storageInfo.storage_used_percentage || 0;

    return (
        <a
            className="StorageIndicator"
            href={`${BLUEBIRD_DOCS_URL}/account/${user?.uid}/storage`}
            target="_blank"
            rel="noopener noreferrer"
            title={`${formatBytes(storageInfo.storage_used_bytes)} of ${formatBytes(storageInfo.storage_limit_bytes)} used — Manage storage`}
        >
            <div className="StorageIndicator__bar">
                <div
                    className={`StorageIndicator__bar-fill ${getBarClass(percentage)}`}
                    style={{ width: `${Math.min(percentage, 100)}%` }}
                />
            </div>
            <span className="StorageIndicator__label">
                {Math.round(percentage)}%
            </span>
        </a>
    );
};

export default StorageIndicator;
